import { Button, Spinner, Flex, ThemeUIStyleObject } from '@apia/theme';
import { TApiaButtonType } from '../../types';
import { getVariant, spacing } from '@apia/theme';

interface IBaseButton {
  text?: string;
  children?: string;
  loadingChildren?: string;
  id?: string;
  name?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  isLoading?: boolean;
  disabled?: boolean;
  variant?: TApiaButtonType | string;
  type?: 'button' | 'submit' | 'reset';
  SXProps?: ThemeUIStyleObject;
}

/**
 * The world's most **basic** button
 */
export const BaseButton = ({
  id,
  name,
  onClick = () => {},
  isLoading = false,
  loadingChildren,
  disabled = false,
  children = '',
  text = '',
  variant = 'primary',
  type = 'button',
  SXProps,
  ...buttonProps
}: IBaseButton) => {
  return (
    <Button
      id={id}
      name={name}
      onClick={onClick}
      {...getVariant(variant)}
      type={type}
      title={children}
      disabled={isLoading || disabled}
      {...buttonProps}
    >
      <Flex
        as="span"
        sx={{
          color: 'inherit',
          width: '100%',
          flexDirection: 'row',
          alignContent: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          gap: spacing(3),
          ...SXProps,
        }}
      >
        {isLoading && (
          <>
            <Spinner size={20} color="inherit" />
            {loadingChildren}
          </>
        )}
        {!isLoading && (children || text)}
      </Flex>
    </Button>
  );
};
